import { commonRequest } from "../../../../services/ApiCall";
import { Helpers } from "../../../../services/Helpers";



export const UrbanTypeServices = {
    fetchUrbanTypeList: async(data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();
        
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.pageSize);
        queryParams.append('searchKey', data.filters.searchKey || '');
        queryParams.append('sortBy', data.filters.sortBy);
        queryParams.append('sortType', data.filters.sortType || 'desc');
        if (data.filters.filterOptions.length>0) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/subscription/fetch/urban-types?${queryParams.toString()}`,{}, Helpers.token());
    },
    urbanTypeListToExport:async(data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();
        queryParams.append('searchKey', data.filters.searchKey || '');
        queryParams.append('sortBy', data.filters.sortBy);
        queryParams.append('sortType', data.filters.sortType || 'desc');
        if (data.filters.filterOptions.length>0) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/subscription/urban-type/export-list?${queryParams.toString()}`,{}, Helpers.token());
    },
    fetchValidUrbanTypeList: async(data)=>{
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/subscription/fetch/urban-type/full-list`,{}, Helpers.token());
    },
    addUrbanType: async(data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/subscription/create/new-urban-type`, data, Helpers.token());
    },
    updateUrbanType: async(data,id)=>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/v2/admin/subscription/update/urban-type/${id}`, data, Helpers.token());
    },
    updateUrbanTypeStatus: async(id)=>{
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/subscription/urban-type/modify-status/${id}`,{}, Helpers.token());
    },
    deleteUrbanType: async(id)=>{
        return await commonRequest("DELETE", `${Helpers.URL()}/api/v2/admin/subscription/delete/urban-type/${id}`,{}, Helpers.token());
    }
}